function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global React, window, Wordmark, Icon, Button, Pill */
// ============================================================================
// Header — clean editorial top nav.
// Top row: announcement bar (dismissible)
// Main row: logo left, primary nav center, utility icons right
// On scroll: bar collapses to hairline.
// ============================================================================
var _React = React,
  useStateHdr = _React.useState,
  useEffectHdr = _React.useEffect,
  useRefHdr = _React.useRef;
function Header(_ref) {
  var _ref$cartCount = _ref.cartCount,
    cartCount = _ref$cartCount === void 0 ? 0 : _ref$cartCount,
    onCartClick = _ref.onCartClick,
    _onNav = _ref.onNav,
    onSearch = _ref.onSearch,
    _ref$current = _ref.current,
    current = _ref$current === void 0 ? "home" : _ref$current;
  var _useStateHdr = useStateHdr(false),
    _useStateHdr2 = _slicedToArray(_useStateHdr, 2),
    menuOpen = _useStateHdr2[0],
    setMenu = _useStateHdr2[1];
  var _useStateHdr3 = useStateHdr(false),
    _useStateHdr4 = _slicedToArray(_useStateHdr3, 2),
    searchOpen = _useStateHdr4[0],
    setSearch = _useStateHdr4[1];
  var _useStateHdr5 = useStateHdr(false),
    _useStateHdr6 = _slicedToArray(_useStateHdr5, 2),
    scrolled = _useStateHdr6[0],
    setScrolled = _useStateHdr6[1];
  var _useStateHdr7 = useStateHdr(false),
    _useStateHdr8 = _slicedToArray(_useStateHdr7, 2),
    annDismissed = _useStateHdr8[0],
    setAnnDismissed = _useStateHdr8[1];
  var _useStateHdr9 = useStateHdr(null),
    _useStateHdr0 = _slicedToArray(_useStateHdr9, 2),
    submenu = _useStateHdr0[0],
    setSubmenu = _useStateHdr0[1];
  useEffectHdr(function () {
    var fn = function fn() {
      return setScrolled(window.scrollY > 8);
    };
    window.addEventListener("scroll", fn);
    return function () {
      return window.removeEventListener("scroll", fn);
    };
  }, []);
  var NAV = [{
    key: "shop",
    label: "Shop",
    items: [{
      k: "shop:new-arrivals",
      t: "New Arrivals"
    }, {
      k: "shop:best-sellers",
      t: "Best Sellers"
    }, {
      k: "shop:feminist",
      t: "Feminist"
    }, {
      k: "shop:lgbtq-pride",
      t: "LGBTQ+ Pride"
    }, {
      k: "shop:protest",
      t: "Protest"
    }, {
      k: "shop:funny-and-political",
      t: "Funny & Political"
    }, {
      k: "shop:womens-tees",
      t: "Women's Tees"
    }, {
      k: "shop:unisex-tees",
      t: "Unisex Tees"
    }, {
      k: "shop:hoodies",
      t: "Hoodies"
    }, {
      k: "shop:accessories",
      t: "Accessories"
    }]
  }, {
    key: "movement",
    label: "The Movement",
    items: [{
      k: "movement:causes",
      t: "Causes We Support"
    }, {
      k: "movement:calendar",
      t: "Protest Calendar"
    }, {
      k: "movement:dispatch",
      t: "The Dispatch"
    }, {
      k: "movement:submit-art",
      t: "Submit Your Art"
    }, {
      k: "movement:artist-portal",
      t: "Artist Portal"
    }]
  }, {
    key: "journal",
    label: "Dispatch"
  }, {
    key: "about",
    label: "About"
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, !annDismissed && /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--ink)",
      color: "var(--bone)",
      padding: "10px 0",
      fontFamily: "var(--font-sans)",
      fontWeight: 400,
      fontSize: 12,
      letterSpacing: "0.05em"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 6,
      height: 6,
      borderRadius: 3,
      background: "var(--rust)"
    }
  }), /*#__PURE__*/React.createElement("span", null, "10% of every order funds grassroots organizing"), /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: 0.4
    }
  }, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "responsive-hide-mobile",
    style: {
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      opacity: 0.85
    }
  }, "Drop 04 now live.")), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setAnnDismissed(true);
    },
    "aria-label": "Dismiss",
    style: {
      background: "transparent",
      border: "none",
      color: "var(--bone)",
      opacity: 0.7,
      cursor: "pointer",
      padding: 4
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: 14
  })))), /*#__PURE__*/React.createElement("header", {
    style: {
      position: "sticky",
      top: 0,
      zIndex: 70,
      background: scrolled ? "rgba(244, 239, 232, 0.92)" : "var(--bone)",
      backdropFilter: scrolled ? "saturate(180%) blur(14px)" : "none",
      WebkitBackdropFilter: scrolled ? "saturate(180%) blur(14px)" : "none",
      borderBottom: "1px solid " + (scrolled ? "var(--line)" : "transparent"),
      transition: "border-color 240ms, background 240ms"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      height: scrolled ? 64 : 80,
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      alignItems: "center",
      gap: 24,
      transition: "height 240ms var(--ease)"
    }
  }, /*#__PURE__*/React.createElement("nav", {
    style: {
      display: "flex",
      gap: 28,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setMenu(true);
    },
    className: "responsive-hide-tablet",
    "aria-label": "Menu",
    style: {
      display: "none",
      background: "transparent",
      border: "none",
      color: "var(--ink)",
      padding: 6,
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "menu",
    size: 22
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setMenu(true);
    },
    className: "hdr-menu-mobile",
    style: {
      background: "transparent",
      border: "none",
      color: "var(--ink)",
      padding: 6,
      cursor: "pointer",
      display: "none"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "menu",
    size: 22
  })), /*#__PURE__*/React.createElement("div", {
    className: "hdr-desktop-nav",
    style: {
      display: "flex",
      gap: 36,
      alignItems: "center"
    }
  }, NAV.map(function (item) {
    var active = current === item.key;
    return /*#__PURE__*/React.createElement("div", {
      key: item.key,
      onMouseEnter: function onMouseEnter() {
        return item.items && setSubmenu(item.key);
      },
      onMouseLeave: function onMouseLeave() {
        return setSubmenu(null);
      },
      style: {
        position: "relative"
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        _onNav === null || _onNav === void 0 || _onNav(item.key);
      },
      style: {
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: 13,
        letterSpacing: "0.02em",
        color: "var(--ink)",
        padding: "8px 0",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        borderBottom: active ? "1px solid var(--ink)" : "1px solid transparent",
        transition: "border-color 160ms"
      },
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.borderBottomColor = "var(--ink)";
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!active) e.currentTarget.style.borderBottomColor = "transparent";
      }
    }, item.label, " ", item.items && /*#__PURE__*/React.createElement(Icon, {
      name: "arrowDown",
      size: 12
    })), item.items && submenu === item.key && /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        top: "100%",
        left: -20,
        marginTop: 0,
        paddingTop: 14,
        animation: "fade-in 160ms var(--ease)"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: "var(--paper)",
        border: "1px solid var(--line)",
        padding: "20px 24px",
        minWidth: 240,
        boxShadow: "0 30px 60px -20px rgba(20,20,20,0.18)"
      }
    }, /*#__PURE__*/React.createElement("ul", {
      style: {
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        gap: 4
      }
    }, item.items.map(function (sub) {
      return /*#__PURE__*/React.createElement("li", {
        key: sub.k
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          _onNav === null || _onNav === void 0 || _onNav(sub.k);
          setSubmenu(null);
        },
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 4px",
          fontFamily: "var(--font-serif)",
          fontWeight: 400,
          fontSize: 20,
          lineHeight: 1.1,
          color: "var(--ink)",
          transition: "color 140ms, gap 200ms"
        },
        onMouseEnter: function onMouseEnter(e) {
          e.currentTarget.style.color = "var(--rust)";
        },
        onMouseLeave: function onMouseLeave(e) {
          e.currentTarget.style.color = "var(--ink)";
        }
      }, /*#__PURE__*/React.createElement("span", null, sub.t), /*#__PURE__*/React.createElement(Icon, {
        name: "arrowR",
        size: 14
      })));
    })))));
  }))), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      _onNav === null || _onNav === void 0 || _onNav("home");
    },
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Wordmark, {
    height: scrolled ? 36 : 48
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 6,
      alignItems: "center",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(UtilButton, {
    onClick: function onClick() {
      return setSearch(true);
    },
    label: "Search"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "search",
    size: 18
  })), /*#__PURE__*/React.createElement(UtilButton, {
    onClick: function onClick() {
      return window.location.href = '/account';
    },
    label: "Account"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "user",
    size: 18
  })), /*#__PURE__*/React.createElement(UtilButton, {
    onClick: onCartClick,
    label: "Cart"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      display: "inline-flex"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "bag",
    size: 18
  }), cartCount > 0 && /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      top: -6,
      right: -8,
      background: "var(--rust)",
      color: "#fff",
      borderRadius: 999,
      fontSize: 9,
      fontWeight: 600,
      width: 16,
      height: 16,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "var(--font-mono)"
    }
  }, cartCount)))))), searchOpen && /*#__PURE__*/React.createElement(SearchOverlay, {
    onClose: function onClose() {
      return setSearch(false);
    },
    onSearch: onSearch
  }), menuOpen && /*#__PURE__*/React.createElement(MenuDrawer, {
    onClose: function onClose() {
      return setMenu(false);
    },
    onNav: function onNav(k) {
      _onNav === null || _onNav === void 0 || _onNav(k);
      setMenu(false);
    },
    NAV: NAV
  }), /*#__PURE__*/React.createElement("style", null, "\n        @media (max-width: 1100px) {\n          .hdr-desktop-nav { display: none !important; }\n          .hdr-menu-mobile { display: inline-flex !important; }\n        }\n      "));
}
function UtilButton(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick,
    label = _ref2.label;
  var _useStateHdr1 = useStateHdr(false),
    _useStateHdr10 = _slicedToArray(_useStateHdr1, 2),
    hover = _useStateHdr10[0],
    setHover = _useStateHdr10[1];
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    "aria-label": label,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      background: "transparent",
      border: "none",
      padding: 10,
      color: hover ? "var(--rust)" : "var(--ink)",
      cursor: "pointer",
      transition: "color 160ms",
      display: "inline-flex"
    }
  }, children);
}

// ----------------------------------------------------------------------------
function SearchOverlay(_ref3) {
  var onClose = _ref3.onClose,
    onSearch = _ref3.onSearch;
  var _useStateHdr11 = useStateHdr(""),
    _useStateHdr12 = _slicedToArray(_useStateHdr11, 2),
    val = _useStateHdr12[0],
    setVal = _useStateHdr12[1];
  useEffectHdr(function () {
    var k = function k(e) {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", k);
    return function () {
      return document.removeEventListener("keydown", k);
    };
  }, [onClose]);
  var POPULAR = ["Good Trouble", "Feminist", "Abortion Rights", "Trucker Hat", "New Arrivals"];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      inset: 0,
      zIndex: 100,
      background: "var(--bone)",
      animation: "fade-in 180ms var(--ease-out)",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      height: 80,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(Wordmark, {
    height: 36
  }), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    style: {
      background: "transparent",
      border: "1px solid var(--ink)",
      color: "var(--ink)",
      padding: "10px 18px",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "0.05em"
    }
  }, "Close ", /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: 14
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      padding: "80px 0 0",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "muted"
  }, "Search the archive"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 28,
      borderBottom: "1px solid var(--ink)",
      display: "flex",
      alignItems: "center",
      gap: 18,
      paddingBottom: 16
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "search",
    size: 28,
    color: "var(--ink)"
  }), /*#__PURE__*/React.createElement("input", {
    autoFocus: true,
    value: val,
    onChange: function onChange(e) {
      return setVal(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        onSearch === null || onSearch === void 0 || onSearch(val);
        onClose();
      }
    },
    placeholder: "What are you looking for?",
    style: {
      flex: 1,
      border: "none",
      outline: "none",
      background: "transparent",
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontWeight: 400,
      fontSize: "clamp(32px, 5vw, 64px)",
      color: "var(--ink)",
      padding: 0
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 56,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 64
    },
    className: "responsive-2col"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: "var(--muted)",
      marginBottom: 16
    }
  }, "Popular searches"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      gap: 8
    }
  }, POPULAR.map(function (p) {
    return /*#__PURE__*/React.createElement("button", {
      key: p,
      onClick: function onClick() {
        onSearch === null || onSearch === void 0 || onSearch(p);
        onClose();
      },
      style: {
        border: "1px solid var(--line-2)",
        background: "transparent",
        padding: "8px 14px",
        fontFamily: "var(--font-sans)",
        fontSize: 13,
        color: "var(--ink)",
        cursor: "pointer"
      },
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.background = "var(--ink)";
        e.currentTarget.style.color = "var(--bone)";
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.color = "var(--ink)";
      }
    }, p);
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: "var(--muted)",
      marginBottom: 16
    }
  }, "Browse by cause"), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: 6
    }
  }, ["Reproductive rights", "Voting rights", "Climate justice", "Trans rights", "Workers' rights", "Immigration justice"].map(function (c) {
    return /*#__PURE__*/React.createElement("li", {
      key: c
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        onSearch === null || onSearch === void 0 || onSearch(c);
        onClose();
      },
      style: {
        fontFamily: "var(--font-serif)",
        fontSize: 22,
        color: "var(--ink)",
        display: "inline-flex",
        gap: 10,
        alignItems: "center"
      },
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.color = "var(--rust)";
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.style.color = "var(--ink)";
      }
    }, c, " ", /*#__PURE__*/React.createElement(Icon, {
      name: "arrowR",
      size: 14
    })));
  }))))));
}

// ----------------------------------------------------------------------------
function MenuDrawer(_ref4) {
  var onClose = _ref4.onClose,
    onNav = _ref4.onNav,
    NAV = _ref4.NAV;
  useEffectHdr(function () {
    var k = function k(e) {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", k);
    return function () {
      return document.removeEventListener("keydown", k);
    };
  }, [onClose]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      inset: 0,
      zIndex: 100,
      background: "var(--bone)",
      animation: "fade-in 180ms",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      height: 80,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(Wordmark, {
    height: 36
  }), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    style: {
      background: "transparent",
      border: "1px solid var(--ink)",
      padding: "10px 18px",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12
    }
  }, "Close ", /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: 14
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      padding: "64px 0",
      flex: 1,
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: 64
    }
  }, NAV.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.key
    }, /*#__PURE__*/React.createElement(Eyebrow, null, item.label), /*#__PURE__*/React.createElement("ul", {
      style: {
        listStyle: "none",
        padding: 0,
        margin: "20px 0 0",
        display: "flex",
        flexDirection: "column",
        gap: 8
      }
    }, (item.items || [{
      k: item.key,
      t: item.label
    }]).map(function (sub) {
      return /*#__PURE__*/React.createElement("li", {
        key: sub.k
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          onNav(sub.k);
        },
        style: {
          fontFamily: "var(--font-serif)",
          fontSize: 32,
          lineHeight: 1.15,
          display: "inline-flex",
          gap: 8,
          alignItems: "center",
          color: "var(--ink)"
        },
        onMouseEnter: function onMouseEnter(e) {
          e.currentTarget.style.color = "var(--rust)";
          e.currentTarget.style.fontStyle = "italic";
        },
        onMouseLeave: function onMouseLeave(e) {
          e.currentTarget.style.color = "var(--ink)";
          e.currentTarget.style.fontStyle = "normal";
        }
      }, sub.t));
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      padding: "24px 0 48px",
      borderTop: "1px solid var(--line)",
      display: "flex",
      gap: 24,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/account",
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 13,
      fontWeight: 500,
      color: "var(--ink)",
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      display: "inline-flex",
      alignItems: "center",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(Icon, {name: "user", size: 16}), "My Account"), /*#__PURE__*/React.createElement("a", {
    href: "/account/login",
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 13,
      fontWeight: 500,
      color: "var(--muted)",
      letterSpacing: "0.08em",
      textTransform: "uppercase"
    }
  }, "Sign In")));
}
Object.assign(window, {
  Header: Header
});

